import { useLocation } from "react-router-dom";

// Returns a function that points internal links at the current language's URLs,
// so German pages link straight to /de/... instead of redirecting through the English URL.
export default function useLocalizedPath() {
  const { pathname } = useLocation();
  const isGerman = isGermanPath(pathname);

  return (path) => {
    if (!isGerman) return path;
    if (path === "/") return "/de";
    if (path.startsWith("/#")) return "/de" + path.slice(1); // "/#ourServices" -> "/de#ourServices"
    return "/de" + path;
  };
}

// True when the current URL is the home page of its language ("/", "/de" or "/de/")
export function isHomePath(pathname) {
  return pathname === "/" || pathname === "/de" || pathname === "/de/";
}

// True only for the German folder itself — "/de" or "/de/..." — not English paths like "/demo" or "/design"
export function isGermanPath(path) {
  return path === "/de" || path.startsWith("/de/");
}

// "/about-us" -> "/de/about-us", "/" -> "/de"
export function toGermanPath(path) {
  if (isGermanPath(path)) return path;
  return path === "/" ? "/de" : "/de" + path;
}

// "/de/about-us" -> "/about-us", "/de" -> "/" — only strips the real /de prefix
export function toEnglishPath(path) {
  if (!isGermanPath(path)) return path;
  return path.slice(3) || "/";
}
